import { cn } from '@/lib/utils';

const LayoutBox1024 = ({
  children,
  className,
  style,
}: {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}) => {
  return (
    <div
      className={cn(
        'flex flex-col m-auto max-w-[1024px] w-full items-center',
        className,
      )}
      style={style}
    >
      {children}
    </div>
  );
};

export default LayoutBox1024;
